import { createContext, useContext, useEffect, useState, useRef } from "react";
import { api, apiError } from "../api";
import { toast } from "sonner";

const AdminCtx = createContext(null);
export const useAdmin = () => useContext(AdminCtx);

export function AdminAuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=authed
  useEffect(() => {
    const t = localStorage.getItem("ozalp_token");
    if (!t) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("ozalp_token"); setUser(false); });
  }, []);
  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("ozalp_token", r.data.token);
    setUser(r.data.user);
  };
  const logout = () => { localStorage.removeItem("ozalp_token"); setUser(false); };
  return <AdminCtx.Provider value={{ user, login, logout }}>{children}</AdminCtx.Provider>;
}

export function ImageUpload({ value, onChange, testId }) {
  const ref = useRef();
  const [yukleniyor, setYukleniyor] = useState(false);
  const sec = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setYukleniyor(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(r.data.url);
    } catch (err) { toast.error(apiError(err)); }
    finally { setYukleniyor(false); }
  };
  return (
    <div className="a-satir">
      {value ? <img src={value.startsWith("data:") || value.startsWith("http") ? value : `${process.env.REACT_APP_BACKEND_URL}${value}`} className="a-thumb" alt="" /> : <div className="a-thumb" />}
      <input ref={ref} type="file" accept="image/*" hidden onChange={sec} data-testid={testId} />
      <button type="button" className="a-btn hayalet kucuk" onClick={() => ref.current.click()} disabled={yukleniyor}>{yukleniyor ? "Yükleniyor…" : "Görsel seç"}</button>
      {value && <button type="button" className="a-btn hayalet kucuk" onClick={() => onChange("")}>Kaldır</button>}
    </div>
  );
}
